// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hover-panel {
  position: absolute;
  bottom: 16px;
  left: 220px;
  z-index: 1100;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1px;
  background: rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  pointer-events: none;
}
.hover-panel.cols-2 {
  grid-template-columns: repeat(2, minmax(148px, 1fr));
  grid-template-rows: repeat(5, auto);
  grid-auto-flow: column;
}
.hover-panel.cols-3 {
  grid-template-columns: repeat(3, minmax(148px, 1fr));
  grid-template-rows: repeat(5, auto);
  grid-auto-flow: column;
}

.hover-zone {
  display: flex;
  align-items: stretch;
  background: rgba(255, 255, 255, 0.93);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.zone-color-bar {
  width: 5px;
  flex: 0 0 5px;
}

.zone-content {
  padding: 6px 10px;
  flex: 1;
  min-width: 0;
}

.zone-label {
  font-weight: 600;
  font-size: 11px;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.zone-sub {
  font-size: 10px;
  color: #666;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 599px) {
  .hover-panel {
    display: none;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .hover-panel {
    left: 256px;
    bottom: 24px;
  }
}
@media (min-width: 1024px) {
  .hover-panel {
    left: 340px;
    bottom: 28px;
  }
  .zone-label {
    font-size: 12px;
  }
  .zone-sub {
    font-size: 10.5px;
  }
  .zone-content {
    padding: 7px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/leaflet-map/components/map-hover-panel/map-hover-panel.component.scss"],"names":[],"mappings":"AAKA;EACE,kBAAA;EACA,YAAA;EAGA,WAAA;EACA,aAAA;EAGA,aAAA;EACA,0BAAA;EAGA,QAAA;EACA,+BAAA;EAEA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,oBAAA;AAXF;AAcE;EACE,oDAAA;EACA,mCAAA;EACA,sBAAA;AAZJ;AAgBE;EACE,oDAAA;EACA,mCAAA;EACA,sBAAA;AAdJ;;AAoBA;EACE,aAAA;EACA,oBAAA;EACA,qCAAA;EACA,0BAAA;EACA,kCAAA;AAjBF;;AAoBA;EACE,UAAA;EACA,aAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,OAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjBF;;AAuBA;EACE;IACE,aAAA;EApBF;AACF;AAwBA;EACE;IACE,WAAA;IACA,YAAA;EAtBF;AACF;AA0BA;EACE;IACE,WAAA;IACA,YAAA;EAxBF;EA2BA;IACE,eAAA;EAzBF;EA4BA;IACE,iBAAA;EA1BF;EA6BA;IACE,iBAAA;EA3BF;AACF","sourcesContent":["// ─── Outer panel ────────────────────────────────────────────────────────────\r\n//  Positioned at the bottom of the map, to the right of the operation-info-card\r\n//  (info card: left 0, bottom 20px, width 200-240px depending on breakpoint).\r\n//  Zones fill top-to-bottom within each column; a new column starts after 5.\r\n\r\n.hover-panel {\r\n  position: absolute;\r\n  bottom: 16px;\r\n  // Default: small screens (<800px) — info card is 200px wide, not shown on small screens anyway.\r\n  // Set a base left that's safe; media queries refine it.\r\n  left: 220px;\r\n  z-index: 1100;\r\n\r\n  // Grid: 1 column by default, 2 or 3 via modifier classes.\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n\r\n  // 1-pixel gaps between cells rendered as the muted background \"grid lines\".\r\n  gap: 1px;\r\n  background: rgba(0, 0, 0, 0.08);\r\n\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n\r\n  // 2-column layout: fill 5 rows top-to-bottom, then wrap to next column.\r\n  &.cols-2 {\r\n    grid-template-columns: repeat(2, minmax(148px, 1fr));\r\n    grid-template-rows: repeat(5, auto);\r\n    grid-auto-flow: column;\r\n  }\r\n\r\n  // 3-column layout.\r\n  &.cols-3 {\r\n    grid-template-columns: repeat(3, minmax(148px, 1fr));\r\n    grid-template-rows: repeat(5, auto);\r\n    grid-auto-flow: column;\r\n  }\r\n}\r\n\r\n// ─── Zone cell ───────────────────────────────────────────────────────────────\r\n\r\n.hover-zone {\r\n  display: flex;\r\n  align-items: stretch;\r\n  background: rgba(255, 255, 255, 0.93);\r\n  backdrop-filter: blur(8px);\r\n  -webkit-backdrop-filter: blur(8px);\r\n}\r\n\r\n.zone-color-bar {\r\n  width: 5px;\r\n  flex: 0 0 5px;\r\n}\r\n\r\n.zone-content {\r\n  padding: 6px 10px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.zone-label {\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  color: #1a1a1a;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.zone-sub {\r\n  font-size: 10px;\r\n  color: #666;\r\n  margin-top: 1px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n// ─── Responsive ─────────────────────────────────────────────────────────────\r\n\r\n// Hide entirely on small/narrow screens (info card is also hidden there).\r\n@media (max-width: 599px) {\r\n  .hover-panel {\r\n    display: none;\r\n  }\r\n}\r\n\r\n// Medium screens: info card is 240px wide.\r\n@media (min-width: 600px) and (max-width: 1023px) {\r\n  .hover-panel {\r\n    left: 256px; // 240px card + 16px gap\r\n    bottom: 24px;\r\n  }\r\n}\r\n\r\n// Large screens: info card expands to 320px wide → push panel clear of it.\r\n@media (min-width: 1024px) {\r\n  .hover-panel {\r\n    left: 340px; // 320px card + 20px gap\r\n    bottom: 28px;\r\n  }\r\n\r\n  .zone-label {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .zone-sub {\r\n    font-size: 10.5px;\r\n  }\r\n\r\n  .zone-content {\r\n    padding: 7px 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
